// File: frontend/src/components/marketing/visuals/MarketingAnalyticsVisual.js
//
// Marketing recreation of the PesaFii Usage Analytics page: active users, avg
// session, data consumption, a peak-hours bar chart, and usage-by-router bars.
// Fictional data; charts draw once in view; no API calls.

import React from "react";
import { Box, Paper, Typography, Stack, LinearProgress, useTheme } from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";
import TimerIcon from "@mui/icons-material/Timer";
import StorageIcon from "@mui/icons-material/Storage";
import { MarketingMetricCard, MarketingMiniBars, SampleNote } from "./primitives";
import { useInViewOnce } from "../motion";
import { DEMO_ANALYTICS } from "../../../data/marketingDemoData";

export default function MarketingAnalyticsVisual() {
  const theme = useTheme();
  const [ref, inView] = useInViewOnce();
  const green = theme.palette.primary.main;

  return (
    <Box ref={ref}>
      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 1, mb: 1.5 }}>
        <MarketingMetricCard label="Active users" value={DEMO_ANALYTICS.activeUsers} icon={GroupIcon} active={inView} color={green} />
        <MarketingMetricCard label="Avg session" value={DEMO_ANALYTICS.avgSessionMins} suffix=" min" icon={TimerIcon} active={inView} color={theme.palette.info.main} />
        <MarketingMetricCard label="Data used" value={DEMO_ANALYTICS.dataGb} suffix=" GB" decimals={1} icon={StorageIcon} active={inView} color={theme.palette.warning.main} />
      </Box>

      <Paper sx={{ p: 1.75, borderRadius: 2.5, border: "1px solid", borderColor: "divider", mb: 1.5 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
          <Typography sx={{ fontSize: 12.5, fontWeight: 700, color: "text.primary" }}>Peak hours</Typography>
          <Typography sx={{ fontSize: 11, color: "text.disabled" }}>{DEMO_ANALYTICS.popularPackage}</Typography>
        </Stack>
        <MarketingMiniBars data={DEMO_ANALYTICS.peakHours} active={inView} color={green} height={80} />
      </Paper>

      <Paper sx={{ p: 1.75, borderRadius: 2.5, border: "1px solid", borderColor: "divider" }}>
        <Typography sx={{ fontSize: 12.5, fontWeight: 700, color: "text.primary", mb: 1 }}>Usage by router</Typography>
        <Stack spacing={1.25}>
          {DEMO_ANALYTICS.usageByRouter.map((u) => (
            <Box key={u.name}>
              <Stack direction="row" justifyContent="space-between" sx={{ mb: 0.4 }}>
                <Typography sx={{ fontSize: 11.5, color: "text.secondary", fontWeight: 600 }}>{u.name}</Typography>
                <Typography sx={{ fontSize: 11.5, color: "text.disabled" }}>{u.pct}%</Typography>
              </Stack>
              <LinearProgress variant="determinate" value={inView ? u.pct : 0}
                sx={{ height: 6, borderRadius: 99, "& .MuiLinearProgress-bar": { bgcolor: green, borderRadius: 99, transition: "transform 1s cubic-bezier(0.22,1,0.36,1)" } }} />
            </Box>
          ))}
        </Stack>
      </Paper>
      <SampleNote />
    </Box>
  );
}
